<template>
    <div class="components-committee-box">
        <div class="box-title">
            <img :src="props.data.icon" alt="" />
            <div class="text">{{props.data.title }}</div> 
        </div>
        <div class="box-list">
            <div class="list-item" v-for="item in props.data.list" :key="item.title">
                <img class="item-icon" :src="item.icon" alt="" />
                <div class="item-title">{{item.title}}</div>
                <div class="item-content">
                    {{item.desc}}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
</script>

<style lang="scss" scoped>
.components-committee-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 96px;
    .box-title{
        display: flex;
        align-items: center;
        img{
            width: 30px;
            height: 30px;
        }
        .text{
            color: rgb(38, 38, 38);
            font-family: 阿里巴巴普惠体 2.0;
            font-size: 28px;
            font-weight: 700;
            line-height: 39px;
            letter-spacing: 0px;
            margin-left: 12px;
        }
    }
    .box-list{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 64px;
        // padding-left: 20px;
        .list-item{
            width: 15%;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 68px;
            .item-icon{
                width: 100px;
                height: 100px;
            }
            .item-title{
                color: rgb(38, 38, 38);
                font-family: Alibaba PuHuiTi 3.0;
                font-size: 18px;
                font-weight: 500;
                letter-spacing: 0px;
                margin-top: 16px;
            }
            .item-content{
                color: rgb(0, 0, 0);
                font-family: Alibaba PuHuiTi 3.0;
                font-size: 12px;
                font-weight: 300;
                line-height: 18px;
                letter-spacing: 0px;
                margin-top: 8px;
                text-align: center;
            }
        }
    }
}
</style>
